import { Icon as o } from "../../icon/index.js";
import { FASTElement as l, observable as d } from "@microsoft/fast-element";
var r = Object.defineProperty, h = (e, t, s, v) => {
  for (var i = void 0, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (i = n(t, s, i) || i);
  return i && r(t, s, i), i;
};
class c extends l {
  postConnectedCallback() {
    this._validationIcon = new o("exclamation-circle"), this._validationIcon.classList.add("validation-icon"), this._validationIcon.setAttribute("slot", "end"), this._isConnected = !0, this.isValid || this.insertBefore(this._validationIcon, this.firstChild);
  }
  postValidate() {
    var t, s;
    (this.isValid = this.control ? this.control.validity.valid : ((t = this.validity) == null ? void 0 : t.valid) || !0) ? (this.classList.remove("invalid"), (s = this._validationIcon) != null && s.parentElement && this.removeChild(this._validationIcon)) : (this.classList.add("invalid"), this._isConnected && this.insertBefore(this._validationIcon, this.firstChild));
  }
}
h([
  d
], c.prototype, "isValid");
export {
  c as InputMixin
};
